module.exports = __webpack_public_path__ + "static/media/新智能闸门-PNG.9d212acc.png";